import { generateAddress } from '@rentspree/helper'

import { H1, H2 } from 'components'
import { TitleWrapper } from 'containers/public-listing/styled'
import { useSelector } from 'store'
import { selectPublicListingPropertyAddress } from 'store/public-listing'
import { COLOR } from 'styles/constants'

export const ListingTitleSection = () => {
  const propertyAddress = useSelector(selectPublicListingPropertyAddress)
  const { street, unitNumber, city, state, zip } = propertyAddress

  return (
    <TitleWrapper id="propertyName">
      <H1
        $size="32px"
        $mSize="22px"
        $lineHeight="48px"
        $mLineHeight="40px"
        $color={COLOR.GREY_LV1}
        $pt={20}
        $weight="700"
      >
        {generateAddress({ street, unitNumber })}
      </H1>
      <H2
        $size="22px"
        $mSize="16px"
        $lineHeight="40px"
        $mLineHeight="24px"
        $color={COLOR.GREY_LV1}
        $weight="400"
        $mWeight="400"
      >
        {generateAddress({ city, state, zipCode: zip })}
      </H2>
    </TitleWrapper>
  )
}
